import React from 'react'

import Content from '../../components/Content';
import Title from '../../components/Title';
import Wrapper from '../../components/Wrapper';

import Slide from "./Slide";

export default (props) => {
  console.log(props, arguments)

  return (
    <Wrapper>
      <Slide>
        <Title>Speaker</Title>
        <Content {...props} />
      </Slide>
    </Wrapper>
  )
}